import { Button, Card, CardContent, CardHeader, Divider, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { useGoBack } from 'src/hooks/common';
import DetailsTable from './components';

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 650,
    margin: '20px auto',
  },
  button: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

const CenterDetails = ({ center }) => {
  const classes = useStyles();
  const { t } = useTranslation(['centers', 'common']);
  const goBack = useGoBack('/app/centers');

  return (
    <Card className={classes.card}>
      <CardHeader
        title={t('labels.detailsCenter_title')}
        subheader={t('labels.detailsCenter_subtitle')}
      />
      <Divider />
      <CardContent>
        <DetailsTable center={center} />

        <Button className={classes.button} variant="outlined" onClick={goBack}>
          {t('common:buttons.back')}
        </Button>
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          component={RouterLink}
          to={`/app/centers/${center.id}/edit`}
        >
          {t('buttons.edit_center')}
        </Button>
      </CardContent>
    </Card>
  );
};

CenterDetails.propTypes = {
  center: PropTypes.object,
};

export default CenterDetails;
